import React from "react";
import { Box, IconButton, ListItemButton, ListItemIcon } from "@mui/material";
import { Fullscreen, FullscreenExit } from "@mui/icons-material";
import { useTranslation } from "react-i18next";
import { yellow } from "@mui/material/colors";
import useFullscreen from "../../hooks/useFullscreen";

const FullscreenToggle = ({ collapsed = false }) => {
  const { isFullscreen, toggleFullscreen } = useFullscreen();
  const { t } = useTranslation();

  return (
    <ListItemButton
      onClick={toggleFullscreen}
      sx={{
        minHeight: 48,
        px: collapsed ? 1.5 : 3,
        borderRadius: 2,
        justifyContent: collapsed ? "center" : "flex-start",
        "&:hover": { bgcolor: "action.hover" },
        width: "100%",
      }}
    >
      <ListItemIcon
        sx={{
          color: yellow[500],
          minWidth: 0,
          mr: collapsed ? 0 : 2,
          justifyContent: "center",
        }}
      >
        {isFullscreen ? <FullscreenExit /> : <Fullscreen />}
      </ListItemIcon>

      {!collapsed && (
        <Box display="flex" alignItems="center">
          {isFullscreen ? t("exitFullScreen") : t("enterFullScreen")}
        </Box>
      )}
    </ListItemButton>
  );
};

export default FullscreenToggle;
